import * as React from 'react';
import { useMergeRefs } from '@floating-ui/react';
import SignatureCanvas from 'react-signature-canvas';
function BEM(props) {
    const { variant = 'dark', disabled, employee, isInvalid, className } = props;
    const classArray = ['signature', `signature--${variant}`];
    if (disabled) {
        classArray.push('signature--disabled');
    }
    if (employee) {
        classArray.push('signature--employee');
    }
    if (isInvalid) {
        classArray.push('signature--invalid');
    }
    if (className) {
        classArray.push(className);
    }
    return classArray.join(' ');
}
const SignatureCore = (props) => {
    const signatureRef = React.useRef(null);
    const signatureCanvasRef = React.useRef(null);
    const [signature, setSignature] = React.useState();
    const [inlineStyles, setInlineStyles] = React.useState();
    const { components, isFocusable = true, helper, label, clearButton, onClear, onEnd, onBegin, elementRef, disabled, children, employee, penColor } = props;
    const ref = useMergeRefs([elementRef, signatureCanvasRef]);
    const { FormHelper, Grid, GridColumn, Button } = components;
    const handleOnEnd = () => {
        var _a;
        const signatureFromCanvas = (_a = signatureCanvasRef.current) === null || _a === void 0 ? void 0 : _a.getCanvas().toDataURL('image/svg+xml');
        setSignature(signatureFromCanvas);
        if (onEnd) {
            onEnd(signatureFromCanvas);
        }
    };
    const handleResize = React.useCallback(() => {
        if (signatureCanvasRef.current) {
            signatureCanvasRef.current.fromDataURL(signature || '');
        }
    }, [signature]);
    React.useEffect(() => {
        if (signatureRef.current) {
            const { clientWidth, clientHeight } = signatureRef.current;
            const aspectRatio = clientWidth < clientHeight ? `${clientHeight} / ${clientWidth}` : `${clientWidth} / ${clientHeight}`;
            setInlineStyles({
                height: 'auto',
                aspectRatio,
            });
        }
    }, []);
    React.useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [handleResize]);
    const getClearButton = (btn) => {
        return (React.createElement(GridColumn, { width: ['xs'] },
            React.createElement(Button, Object.assign({ size: "small", iconLeft: "#close", variant: "secondary", type: employee ? 'employee' : undefined, disabled: disabled }, btn, { onClick: onClear }))));
    };
    const getCanvas = () => {
        if (disabled) {
            return null;
        }
        return (React.createElement(SignatureCanvas, { canvasProps: {
                className: 'signature__canvas-inner',
            }, onBegin: onBegin, onEnd: handleOnEnd, ref: ref, penColor: penColor }));
    };
    return (React.createElement("div", { className: BEM(props) },
        React.createElement(Grid, { align: ['between-xs', 'middle-xs'] },
            React.createElement(GridColumn, { width: ['xs'], className: "signature__label-wrapper" },
                React.createElement("span", { className: "signature__label" }, label)),
            clearButton && getClearButton(clearButton)),
        React.createElement("div", { className: "signature__canvas", ref: signatureRef, style: inlineStyles, tabIndex: isFocusable ? 0 : undefined }, children ? children : getCanvas()),
        helper && React.createElement(FormHelper, Object.assign({ className: "signature__form-helper" }, helper))));
};
export default SignatureCore;
